import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

// Routes
import { LoginRoutingModule } from './login-routing.module';

@NgModule({
  declarations: [ LoginRoutingModule.components ],
  imports: [
    LoginRoutingModule,
    RouterModule,
    SharedModule
  ],
  exports: []
})
export class LoginModule{}
